// QA environment — used for QA builds.
// Real values are injected at build time via CI/CD environment variables or Azure App Config.
export const environment = {
  production: false,
  msalConfig: {
    clientId: 'b329fc64-a3d0-4226-8dfc-0de91376203c',
    authority: 'https://quantiosidtest.ciamlogin.com/bec06dc5-b5d0-4471-85c9-ce7f1288f94d',
    knownAuthorities: [] as string[],
    redirectUri: '/',
    postLogoutRedirectUri: '/auth',
  },
  apiScopes: ['api://bece079f-504c-4442-9779-85aa38dc7d33/user_impersonation'],
};
